import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "condicional-create-page"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-5"
  }, [_c('div', [_c('h3', {
    staticClass: "mb-1"
  }, [_vm._v(_vm._s(_vm.tituloPagina))]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" " + _vm._s(_vm.subtituloPagina) + " ")])]), _c('button', {
    staticClass: "btn btn-light font-weight-bolder",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'condicionalMercadorias'
        });
      }
    }
  }, [_vm._v(" Voltar ")])]), _c('div', {
    staticClass: "card mb-5"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente",
      "label-for": "cliente"
    }
  }, [_vm.form.responsabilidade_vendedor ? _c('b-form-input', {
    attrs: {
      "id": "cliente",
      "value": "Responsabilidade do vendedor",
      "readonly": ""
    }
  }) : _c('VueSelect', {
    staticClass: "busca-cliente",
    attrs: {
      "id": "cliente",
      "options": _vm.clientes,
      "filterable": false,
      "label": "nome",
      "placeholder": "Informe o nome do cliente"
    },
    on: {
      "search": _vm.buscarClientes
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', [_c('strong', [_vm._v(_vm._s(option.nome))]), _c('div', {
          staticClass: "text-muted small"
        }, [_vm._v(" " + _vm._s(option.cpf_cnpj || option.cnpj_cpf ? _vm.formatCpfCnpj(option.cpf_cnpj || option.cnpj_cpf) : "-") + " ")])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.nome) + " ")];
      }
    }, {
      key: "no-options",
      fn: function fn() {
        return [_vm._v("Informe o nome do cliente")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cliente", $$v);
      },
      expression: "form.cliente"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Responsabilidade do vendedor",
      "label-for": "responsabilidade_vendedor"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "condicional-responsabilidade-flag",
    attrs: {
      "id": "responsabilidade_vendedor",
      "switch": ""
    },
    on: {
      "change": _vm.alterarResponsabilidadeVendedor
    },
    model: {
      value: _vm.form.responsabilidade_vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "responsabilidade_vendedor", $$v);
      },
      expression: "form.responsabilidade_vendedor"
    }
  }, [_vm._v(" Sim ")])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Vendedor",
      "label-for": "vendedor"
    }
  }, [_c('VueSelect', {
    attrs: {
      "id": "vendedor",
      "options": _vm.vendedores,
      "filterable": false,
      "label": "nome",
      "placeholder": "Informe o vendedor"
    },
    on: {
      "open": _vm.buscarVendedores,
      "search": _vm.buscarVendedores
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function fn() {
        return [_vm._v("Informe o nome do vendedor")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.vendedor,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vendedor", $$v);
      },
      expression: "form.vendedor"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de saída",
      "label-for": "data_saida"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "data_saida",
      "type": "date"
    },
    model: {
      value: _vm.form.data_saida,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_saida", $$v);
      },
      expression: "form.data_saida"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Limite de retorno",
      "label-for": "data_limite_retorno"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "data_limite_retorno",
      "type": "date"
    },
    model: {
      value: _vm.form.data_limite_retorno,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "data_limite_retorno", $$v);
      },
      expression: "form.data_limite_retorno"
    }
  })], 1)], 1)], 1), _c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label": "Observação",
      "label-for": "observacao"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "observacao",
      "rows": "2",
      "max-rows": "4"
    },
    model: {
      value: _vm.form.observacao,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "observacao", $$v);
      },
      expression: "form.observacao"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "card mb-5"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    attrs: {
      "align-v": "end"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Produto",
      "label-for": "produto"
    }
  }, [_c('VueSelect', {
    ref: "produtoSelect",
    attrs: {
      "id": "produto",
      "options": _vm.produtos,
      "filterable": false,
      "label": "descricao",
      "placeholder": "Busque por nome, código ou código de barras"
    },
    on: {
      "search": _vm.buscarProdutos,
      "input": _vm.selecionarProduto
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', [_c('strong', [_vm._v(_vm._s(option.descricao))]), _c('div', {
          staticClass: "text-muted small"
        }, [_vm._v(" Código: " + _vm._s(option.codigo || "-") + " · Referência: " + _vm._s(option.referencia || "-") + " · Estoque: " + _vm._s(_vm.formatQuantidade(_vm.estoqueDisponivel(option))) + " · Reservado: " + _vm._s(_vm.formatQuantidade(option.quantidade_reservada_condicional)) + " "), _vm.combinacaoLabel(option) ? _c('span', {
          staticClass: "ml-2"
        }, [_vm._v(" · " + _vm._s(_vm.combinacaoLabel(option)) + " ")]) : _vm._e()])])];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(option.descricao) + " ")];
      }
    }, {
      key: "no-options",
      fn: function fn() {
        return [_vm._v("Informe ao menos 3 caracteres")];
      },
      proxy: true
    }]),
    model: {
      value: _vm.produtoSelecionado,
      callback: function callback($$v) {
        _vm.produtoSelecionado = $$v;
      },
      expression: "produtoSelecionado"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Estoque disponível",
      "label-for": "estoque"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "estoque",
      "value": _vm.formatQuantidade(_vm.estoqueProdutoSelecionado),
      "readonly": ""
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Quantidade",
      "label-for": "quantidade"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "quantidade",
      "type": "number",
      "min": "0.0001",
      "step": "0.0001"
    },
    model: {
      value: _vm.item.quantidade,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "quantidade", _vm._n($$v));
      },
      expression: "item.quantidade"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Valor unitário",
      "label-for": "valor_unitario"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "valor_unitario",
      "type": "number",
      "min": "0",
      "step": "0.01"
    },
    model: {
      value: _vm.item.valor_unitario,
      callback: function callback($$v) {
        _vm.$set(_vm.item, "valor_unitario", _vm._n($$v));
      },
      expression: "item.valor_unitario"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "1"
    }
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Adicionar item',
      expression: "'Adicionar item'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button",
      "disabled": _vm.carregandoEstoqueProduto
    },
    on: {
      "click": _vm.adicionarItem
    }
  }, [_vm._v(" + ")])])], 1), _c('div', {
    staticClass: "table-responsive mt-4"
  }, [_c('table', {
    staticClass: "table table-sm table-striped"
  }, [_vm._m(0), _c('tbody', [_vm.form.itens.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-6",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(" Nenhum produto incluído. ")])]) : _vm._e(), _vm._l(_vm.form.itens, function (itemLinha, index) {
    return _c('tr', {
      key: itemLinha.uid
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(itemLinha.descricao))]), _c('div', {
      staticClass: "text-muted small"
    }, [_vm._v(" Código: " + _vm._s(itemLinha.codigo || "-") + ", Referência: " + _vm._s(itemLinha.referencia || "-") + " "), _vm.combinacaoLabel(itemLinha) ? _c('span', {
      staticClass: "ml-2"
    }, [_vm._v(" · " + _vm._s(_vm.combinacaoLabel(itemLinha)) + " ")]) : _vm._e()])]), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" " + _vm._s(_vm.formatQuantidade(itemLinha.estoque_disponivel)) + " ")]), _c('td', {
      staticClass: "text-right"
    }, [_c('b-form-input', {
      staticClass: "text-right condicional-number-input",
      attrs: {
        "type": "number",
        "min": "0.0001",
        "step": "0.0001"
      },
      on: {
        "change": function change($event) {
          return _vm.validarQuantidadeLinha(itemLinha);
        }
      },
      model: {
        value: itemLinha.quantidade,
        callback: function callback($$v) {
          _vm.$set(itemLinha, "quantidade", _vm._n($$v));
        },
        expression: "itemLinha.quantidade"
      }
    })], 1), _c('td', {
      staticClass: "text-right"
    }, [_c('b-form-input', {
      staticClass: "text-right condicional-number-input",
      attrs: {
        "type": "number",
        "min": "0",
        "step": "0.01"
      },
      model: {
        value: itemLinha.valor_unitario,
        callback: function callback($$v) {
          _vm.$set(itemLinha, "valor_unitario", _vm._n($$v));
        },
        expression: "itemLinha.valor_unitario"
      }
    })], 1), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(" R$ " + _vm._s(_vm.formatValor(_vm.totalItem(itemLinha))) + " ")]), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.removerItem(index);
        }
      }
    }, [_vm._v(" Remover ")])])]);
  })], 2), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(" " + _vm._s(_vm.formatQuantidade(_vm.totalQuantidade)) + " ")]), _c('th'), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("R$ " + _vm._s(_vm.formatValor(_vm.totalGeral)))]), _c('th')])])])])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn btn-light-primary font-weight-bolder mr-3",
    attrs: {
      "type": "button",
      "disabled": _vm.salvando || _vm.carregando
    },
    on: {
      "click": function click($event) {
        return _vm.salvar(false);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.editando ? "Salvar alterações" : "Salvar rascunho") + " ")]), _vm.podeConfirmarSaida ? _c('button', {
    staticClass: "btn btn-primary font-weight-bolder",
    attrs: {
      "type": "button",
      "disabled": _vm.salvando || _vm.carregando
    },
    on: {
      "click": _vm.confirmarSalvarSaida
    }
  }, [_vm._v(" Salvar e confirmar saída ")]) : _vm._e()])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Produto")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Estoque")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Quantidade")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Valor unitário")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Total")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Ações")])])]);
}];
export { render, staticRenderFns };